// extracted by mini-css-extract-plugin
module.exports = {"scrollableAssignmentsContainer":"styles_scrollableAssignmentsContainer__3zLaG","assignmentBox":"styles_assignmentBox__258MG","slideInFromRight":"styles_slideInFromRight__1uL7q"};